/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ project: NonNullable<unknown>, error: NonNullable<unknown> }} Explorer_Info_Batch_Error_ProjectInputs */

const en_explorer_info_batch_error_project = /** @type {(inputs: Explorer_Info_Batch_Error_ProjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.project}: ${i?.error}`)
};

const fr_explorer_info_batch_error_project = /** @type {(inputs: Explorer_Info_Batch_Error_ProjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.project}: ${i?.error}`)
};

const de_explorer_info_batch_error_project = /** @type {(inputs: Explorer_Info_Batch_Error_ProjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.project}: ${i?.error}`)
};

const it_explorer_info_batch_error_project = /** @type {(inputs: Explorer_Info_Batch_Error_ProjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.project}: ${i?.error}`)
};

const ru_explorer_info_batch_error_project = /** @type {(inputs: Explorer_Info_Batch_Error_ProjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.project}: ${i?.error}`)
};

const es_explorer_info_batch_error_project = /** @type {(inputs: Explorer_Info_Batch_Error_ProjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.project}: ${i?.error}`)
};

const zh_cn2_explorer_info_batch_error_project = /** @type {(inputs: Explorer_Info_Batch_Error_ProjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.project}: ${i?.error}`)
};

const ja_explorer_info_batch_error_project = /** @type {(inputs: Explorer_Info_Batch_Error_ProjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.project}: ${i?.error}`)
};

const hi_explorer_info_batch_error_project = /** @type {(inputs: Explorer_Info_Batch_Error_ProjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.project}: ${i?.error}`)
};

const pt_pt2_explorer_info_batch_error_project = /** @type {(inputs: Explorer_Info_Batch_Error_ProjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.project}: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "{project}: {error}" |
*
* @param {Explorer_Info_Batch_Error_ProjectInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_batch_error_project = /** @type {((inputs: Explorer_Info_Batch_Error_ProjectInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Batch_Error_ProjectInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_batch_error_project(inputs)
	if (locale === "de") return de_explorer_info_batch_error_project(inputs)
	if (locale === "it") return it_explorer_info_batch_error_project(inputs)
	if (locale === "ru") return ru_explorer_info_batch_error_project(inputs)
	if (locale === "es") return es_explorer_info_batch_error_project(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_batch_error_project(inputs)
	if (locale === "ja") return ja_explorer_info_batch_error_project(inputs)
	if (locale === "hi") return hi_explorer_info_batch_error_project(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_batch_error_project(inputs)
	return en_explorer_info_batch_error_project(inputs)
});